import react, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Animation } from 'ui/animation'

export type Props = {
  show: boolean
  //TODO: исправить
  Wrapper: any
}

export const HorizontalMoveAnimation: FC<Props> = ({ children, show, Wrapper = <></> }) => {
  const [shouldRender, setShouldRender] = useState(show)

  useEffect(() => {
    if (show) setShouldRender(true)
  }, [show])

  return shouldRender ? (
    <Wrapper>
      <Animation
        type={show ? 'appear-from-left' : 'dissapear-to-left'}
        duration={0.2}
        onAnimationEnd={() => {
          if (!show) {
            setShouldRender(false)
          }
        }}
        style={{ height: '100%' }}
      >
        {children}
      </Animation>
    </Wrapper>
  ) : null
}
